export enum NemsisCodes {
  HOSPITAL_NON_EMERGENCY_DEPARTMENT_BED = 4221005,
  EMS_GROUND_DEFAULT = 4221017,
  PICKUP_DEFAULT_HOSPITAL_CODE = 'Y92.23',
  PICKUP_DEFAULT_EMS_CODE = 'Y92.81',
}
